import { inject, Signal } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserStore } from '@shared/stores/user.store';

export const adminMenuGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  const isClassificationManager$: Signal<boolean> = userStore.isClassificationManager;

  if (!isClassificationManager$())
    router!.navigate(['/home']);

  return true;
}
